module.exports = __webpack_public_path__ + "img/storyboard-pro-creation.7060d94d.webp";